module.exports = __webpack_public_path__ + "img/ploze.1eec9ce6.png";